import Model from './Model'

export default class Task extends Model {
    static async all(query = null, packageReference = null) {
        const config = {params: {query, packageReference}}
        const {data} = await Http.get(route('api.v1.tasks.index'), config)
        return this.make(data)
    }

    static async incomplete() {
        const config = {params: {incomplete: true}}
        const {data} = await Http.get(route('api.v1.tasks.index'), config)
        return this.make(data)
    }

    async resolve() {
        const {data} = await Http.put(route('api.v1.tasks.resolve', this.id))

        this.fill(data);
    }

    getAssignees() {
        return this.assignees.map((a) => a.name).join(', ');
    }

    async reopen() {
        const {data} = await Http.put(route('api.v1.tasks.reopen', this.id))

        this.fill(data);
    }

    getFormAttributes() {
        const attributes = this.only(['name', 'description', 'due', 'assignees', 'package'])

        return attributes
    }

    static async create(attributes) {
        const url = route('api.v1.tasks.store')
        const payload = this.parseAttributes(attributes)
        const {data} = await Http.post(url, payload)
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v1.tasks.update', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const {data} = await Http.put(url, payload)
        return this.fill(data)
    }
}
